export default __webpack_public_path__ + "static/media/MAG_hazard_map.0a430fb6.jpg";